export default __webpack_public_path__ + "static/media/bet12.afce5c74.png";